// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-704f3768","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/sass-resources-loader/lib/loader.js?{"resources":"/tmp/build_e2c4a3aa/src/style/_variables.scss"}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/mainMenu/MainMenu.vue
// module id = Y1V1
// module chunks = 1